export enum Permissions {
    FULL_ACCESS = "full",
    VIEW_MAP = "map.view",
    APPLICATION_ACCESS = "application.access",
    //VIEW_MOST_RECENT_VEHICLE_LOGS = "ViewMostRecentVehicleLogs",
    VIEW_VEHICLE_HISTORY_LOGS = "vehicle_log.view",
    ADD_EDIT_DEALERSHIPS = "dealership.edit",
    //ADD_EDIT_AUTO_GROUPS = "AddEditAutoGroups",
    //ADD_EDIT_SEARCH_DOMAINS = "AddEditSearchDomains",
    //ADD_EDIT_AREAS = "AddEditAreas",
    ADD_EDIT_USERS = "user.edit",
    //ADD_DEALERSHIP_CONTACT = "AddDealershipContact",
    //ADD_VEHICLE_LOG = "AddVehicleLog",
    ADD_EDIT_PERMISSIONS = "user.permission.edit",
    VIEW_OPERATION_REVENUE = "operation.revenue.view",
    VIEW_OPERATION_STOREVISIT = "operation.store_visit.view",
    VIEW_OPERATION_WORKSHEET = "operation.worksheet.view"
}

export enum PreInspectionResponse {
    APPROVED = "approved",
    DECLINED = "declined",
    NOT_READY = "not_ready",
    SOLD = "sold"
}

export const getPreInspectionResponseLabel = (identifier: string) => {
    switch (identifier) {
        case PreInspectionResponse.APPROVED:
            return "Approved";
        case PreInspectionResponse.DECLINED:
            return "Declined";
        case PreInspectionResponse.NOT_READY:
            return "Not ready";
        case PreInspectionResponse.SOLD:
            return "Sold";
        default:
            return "Unknown type";
    }
};

export enum VehicleFilter {
    ALL = "all",
    APPROVED = "approved",
    DECLINED = "declined",
    NOT_READY = "not_ready",
    INSPECTED = "inspected",
    SOLD = "sold",
    NEW = "new",
    FRONTLINE = "frontline",
    LIVE = "live"
}

export enum VehicleStateType {
    ACCIDENT = "accident",
    MINOR_DAMAGE = "minor_damage",
    NO_DAMAGE = "no_damage",
    OTHER_DAMAGE = "other_damage",
    STRUCTURE = "structure"
}

export const getVehicleStateLabel = (identifier: string) => {
    switch (identifier) {
        case VehicleStateType.ACCIDENT:
            return "Accident";
        case VehicleStateType.NO_DAMAGE:
            return "No damage";
        case VehicleStateType.STRUCTURE:
            return "Structure";
        case VehicleStateType.MINOR_DAMAGE:
            return "Minor damage";
        case VehicleStateType.OTHER_DAMAGE:
            return "Other damage";
        default:
            return "Unknown type";
    }
};

export enum DealershipViewType {
    NORMAL,
    APPROVAL
}

export interface User {
    id: number;
    first_name: string;
    last_name: string;
    created: string;
    email: string;
}

export interface Permission {
    name: string;
    description: string;
}

export interface SearchPath {
    domain_id: number;
    host: string;
    uri: string;
}

export interface SearchDomain {
    id: number;
    host: string;
    vehicle_class: string;
    navigation_class_next: string | null;
    navigation_class_more: string | null;
    associated_dealership_count: number;
}

export interface Area {
    id: number;
    name: string;
}

export interface AutoGroup {
    id: number;
    name: string;
}

export interface Dealership {
    id: number;
    name: string;
    latitude: number;
    longitude: number;
    is_active: boolean;
    has_recent_accidents: boolean;
    dealership_uri: string;
    street_address: string | null;
}

export interface DealershipContact {
    id: number;
    first_name: string;
    last_name: string;
    title: string;
    cell_number: string;
    work_number: string;
    email: string;
    availability: string;
    point_of_contact: boolean;
    decision_maker: boolean;
}

export interface VehicleLog {
    id: number;
    vehicle_state: string;
    vin: string;
    year: number;
    make: string;
    model: string;
    price: number;
    created: string;
    dealership_uri: string;
    dealership_name: string;
    found_by: string | null;
    last_pre_inspection_response: string | null;
    page_url: string | null;
    image_url: string | null;
    report_link: string | null;
}

export interface HistoricalDealershipLog {
    name: string;
    uri: string;
    date_found: string;
    accidents_found: number;
    is_dealership_active: boolean;
    live_count: number;
}

export interface HistoricalVehicleLog {
    dealership_name: string;
    date_found: string;
    year: number;
    make: string;
    model: string;
    price: number;
    image_url: string | null;
    page_url: string | null;
    vehicle_state: string;
}

export interface CrawlerQueue {
    id: number;
    name: string;
}

export interface StoreVisit {
    dealerName: string;
    value: string;
    description: string;
    displayName: string;
    mapUrl: string;
    date: {
        _nanoseconds: number
    }
}

export interface ScheduleTask {
    id: number;
    name: string;
    is_active: boolean;
    areas: Area[]
    dealerships: Area[] // TODO update
    days: {
        monday: boolean;
        tuesday: boolean;
        wednesday: boolean;
        thursday: boolean;
        friday: boolean;
        saturday: boolean;
        sunday: boolean;
    }
}
